import { createFileRoute } from '@tanstack/react-router';
import CountryView from '../../../features/baseData/countries/country/view';
import {
  COUNTRIES_PERMISSIONS,
  createPermissionGuard,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute('/stammdaten/laender/$countryId')({
  component: CountryView,
  beforeLoad: createPermissionGuard(
    getPermissionSet(COUNTRIES_PERMISSIONS, 'READ'),
  ),
});

export const ViewCountryRoute = Route;
